export const getProductPricingQueryParameters = ({ productListing }) => {
  return {
    productQuery: {
      masterProductId: {
        in: productListing?.reduce(
          (acc, currentProduct) => [...acc, currentProduct?.masterProductId],
          []
        ),
      },
    },
  };
};
